const common: Record<string, string> = {
  'nav.about': '关于我们',
  'nav.services': '服务',
  'nav.categories': '类别',
  'nav.onboarding': '客户入驻',
  'nav.countries': '国家',
  'nav.updates': '动态',
  'nav.contact': '联系',
  'nav.getStarted': '立即开始',
  'nav.menu': '菜单',
  'lang.switch': '语言',
};
export default common;
